import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const latestImportStatus = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ORGANIZATION_SETTINGS.LATEST_IMPORT_STATUS
  );
};

export default latestImportStatus;
